import { createSelector } from 'reselect';

const getChaptersSelector = state => state.memos.chapters.chapters;
const getParagraphsSelector = state => state.memos.chapters.paragraphs;

function paragraphsForChapter(paragraphs, chapter) {
  return paragraphs
    .filter(p => p.chapter.toString() === chapter.id.toString())
    .sortBy(p => p.order)
    .toArray();
}

export const getChaptersWithParagraphs = createSelector(
  getChaptersSelector,
  getParagraphsSelector,
  (chapters, paragraphs) => {
    return chapters
      .map(c => {
        return {
          ...c,
          paragraphs: paragraphsForChapter(paragraphs, c),
        };
      })
      .sortBy(c => c.order)
      .toArray();
  }
);



// WEBPACK FOOTER //
// ./src/modules/memo/selectors/chapter.js